import React, { Dispatch, useCallback } from 'react';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { updateLanguage } from '../../../redux/user/sliceUserSettings';
import { labelFontSemiBold, vars } from '../../../Theme';

/**
 * MenuItem component that allows the user to change the application language.
 */
export default ({ lang: language }: { lang: string }) => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'header' });

    const dispatch: Dispatch<unknown> = useDispatch();

    const { i18n } = useTranslation();

    /**
     * Callback that sets the application language.
     */
    const handleChangeLang = useCallback(() => {
        i18n.changeLanguage(language);
        dispatch(updateLanguage({ language }));
    }, [language]);

    return (
        <MenuItem
            selected={language === i18n.language}
            sx={{
                fontFamily: labelFontSemiBold,

                '&.Mui-selected': {
                    color: vars.brandGreen,
                    backgroundColor: 'transparent',

                    '&:hover': {
                        color: vars.selectedHoveredGreen,
                    },
                },
            }}
            onClick={handleChangeLang}
        >
            {t(language)}
        </MenuItem>
    );
};
